var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4" },
              [
                _c("c-datepicker", {
                  attrs: {
                    range: true,
                    defaultStart: "-1M",
                    defaultEnd: "0M",
                    label: "목표작업일",
                    name: "plantDts",
                  },
                  model: {
                    value: _vm.searchParam.plantDts,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantDts", $$v)
                    },
                    expression: "searchParam.plantDts",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "정비오더 목록",
            columns: _vm.grid.columns,
            data: _vm.grid.data,
            gridHeight: "500px",
            isExcelDown: false,
            isFullScreen: false,
            columnSetting: false,
            selection: "single",
            rowKey: "workPlanId",
          },
          on: { linkClick: _vm.linkClick, rowDblclick: _vm.rowDblclick },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  col.name === "woWorkPlanStepCd"
                    ? [
                        _c(
                          "q-chip",
                          {
                            staticClass: "full-size-chip",
                            class:
                              props.row.woWorkPlanStepCd == "WWPSC00000"
                                ? "blinking"
                                : "",
                            attrs: {
                              color: _vm.getColors(props.row.woWorkPlanStepCd),
                              outline: "",
                              square: "",
                              "text-color": "white",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(props.row.woWorkPlanStepName) + " "
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "검색", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                  _c("c-btn", {
                    attrs: { label: "선택", icon: "check" },
                    on: { btnClicked: _vm.select },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }